import { getUrl, Post, Get, Put, Patch } from '.'

export const Create = async body => {
  return Post(getUrl('cnps.sur.team-user-create'), body)
}

export const List = async body => {
  return Post(getUrl('cnps.sur.team-user-get-list'), body)
}

export const Update = async body => {
  return Post(getUrl('cnps.sur.team-user-edit'), body)
}

export const Detail = async body => {
  return Post(getUrl('cnps.sur.team-user-get-detail'), body)
}

export const UpdateStatus = async body => {
  return Post(getUrl('cnps.sur.team-user-update-status'), body)
}
